export default __webpack_public_path__ + "static/media/simProfile-4.d1a33da1.png";